import { MSAL_AUTHORITY, MSAL_CLIENT_ID } from "./shared/constants";
import { LOGIN, ROUTE_ADMIN_LOGIN, ROUTE_LOGIN } from "./shared/routes/auth.routes";

// src/msalConfig.js
export const msalConfig = {
  auth: {
    clientId: MSAL_CLIENT_ID, // Replace with your Azure AD Application (Client) ID
    authority: MSAL_AUTHORITY, // Replace with your Azure AD Tenant ID
    redirectUri: window.location.origin + ROUTE_LOGIN, // Where the user will be redirected after login
  },
  cache: {
    cacheLocation: "sessionStorage", // sessionStorage or localStorage
    storeAuthStateInCookie: false, 
  },
};

export const loginRequest = {
  scopes: ["User.Read", "profile", "openid", "email"], // Permissions you want the user to consent to
};
